module.exports = {
  user: {
    key: 'user',
    label: 'User',
  },
  org: {
    key: 'org',
    label: 'Organization',
  },
  page: {
    key: 'page',
    label: 'Page',
  },
  book: {
    key: 'book',
    label: 'Book',
  },
  library: {
    key: 'library',
    label: 'Library',
  },
};